<template>
  <section class="enrolment-congratulations">
    <header class="enrolment-congratulations__header">
      <span class="enrolment-congratulations__icon" aria-hidden="true">
        <img src="~/images/check-fill.svg" class="icon" v-svg-inline>
      </span>
      <div>
        <p class="enrolment-congratulations__caption">Поздравляем с зачислением</p>
        <h3>Дорогой студент!</h3>
      </div>
    </header>

    <div class="enrolment-congratulations__body">
      <p>
        Поздравляем с поступлением! Теперь ты — часть большой, дружной и очень талантливой
        семьи ТУСУРа.
      </p>
      <p>
        Добро пожаловать в наш университет! Здесь тебя ждут люди, которые станут друзьями,
        знания, которые откроют двери в профессию, и атмосфера, в которую невозможно не
        влюбиться. Ты выбрал не просто вуз — ты выбрал место, где начинается твоё будущее.
      </p>
    </div>

    <footer class="enrolment-congratulations__footer">
      <p>
        С гордостью и теплотой,<br>
        <strong>Приемная комиссия ТУСУРа!</strong>
      </p>
      <p class="enrolment-congratulations__postscript">
        P.S. Готовься к незабываемому студенчеству!
      </p>
    </footer>
  </section>
</template>
